import LineDividersWithContent from "components/LineDividersWithContent";
import React, { useEffect, useState } from "react";
import "./claimSupport.css"
import { flattenArray, starLineWrapperJsx, starLineWrapperJsxWordBreak } from "utlis/utils";

const ServicingManagerJSX = ({ neoManagers }) => {
    
    const [normalizedFlattenedArray, setNormalizedFlattenedArray] = useState(neoManagers)

    useEffect(() => {
        const updatedArray = flattenArray(neoManagers)
        setNormalizedFlattenedArray(updatedArray)
    }, [neoManagers])

    if (neoManagers && neoManagers.length === 0) {
        return null
    }

    return (
        <div>

            <div style={{ marginTop: "60px" }}>
                {starLineWrapperJsxWordBreak(
                    <span className="contact-detail-heading">
                        Contacts for Neo Risk Management and Insurance Brokers
                    </span>, "28px", "28px"
                )}

                <div style={{ marginTop: "24px"}} className="support-cards-grid">
                    {normalizedFlattenedArray.map((each_contact, idx) => (
                        <div className="claimSupportCard" key={idx}>

                            <div class="spacing-css">
                                <div>
                                    <span className="maternity-card-heading-css">
                                        {each_contact?.role}
                                    </span>
                                </div>
                                <div className="gold-line-css" />
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Name"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.name}
                                </span>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Mobile Number"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.phone}
                                </span>
                            </div>

                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "16px",
                                gap: "8px"
                            }}>
                                <span className='maternity-max-limit-heading'>
                                    {"Email"}
                                </span>
                                <span className='maternity-max-limit-value'>
                                    {each_contact?.email}
                                </span>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServicingManagerJSX;
